import { useMutation } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { ReferenceEntity } from '../lib/entities/reference';
import { FeedbackState } from '../types/feedback';

interface FeedbackUpdateRequest {
	feedbackId: string;
	isDraft: boolean;
	receiverId: string;
	reference?: ReferenceEntity;
	text: string;
}

export const useUpdateFeedbackApi = (options = {}) => {
	const http = useHttpClient('v2');

	return useMutation(
		(data: FeedbackUpdateRequest) => {
			const params = {
				id: data.feedbackId,
				receiver_id: data.receiverId,
				state: data.isDraft ? FeedbackState.Draft : FeedbackState.Published,
				text: data.text,
			};

			if (data.reference) {
				Object.assign(params, {
					reference_id: data.reference.id,
					reference_type: data.reference.type,
				});
			}

			return http.put<any>(`/constructive_feedback/feedback/${data.feedbackId}`, params);
		},
		{
			retry: false,
			...options,
		}
	);
};
